/* eslint-disable no-lone-blocks */
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import axios from 'axios'
import {toast} from 'react-toastify'
import {ENV} from '../../../Utils/_helpers/EnvHelper'
const initialState = {
  signUpDetails: {},
}

const API_URL = ENV().REACT_APP_API_URL

export const fetchAsyncSignUp: any = createAsyncThunk(
  'signUp/fetchAsyncSignUp',
  async (data, {rejectWithValue}) => {
    try {
      const response = await axios.post(`${API_URL}auth/signup`, data)
      return response.data
    } catch (err: any) {
      return rejectWithValue(err.response.data)
    }
  }
)

const signUpSlice = createSlice({
  name: 'signUp',
  initialState,
  reducers: {
    clearSignUpData: (state) => {
      return {...state, signUpDetails: {}}
    },
  },
  extraReducers: {
    [fetchAsyncSignUp.pending]: (state) => {},
    [fetchAsyncSignUp.fulfilled]: (state, {payload}) => {
      {
        payload.status === true ? toast.success(payload.message) : toast.error(payload.message)
      }
      return {...state, signUpDetails: payload}
    },
    [fetchAsyncSignUp.rejected]: (state, {payload}) => {
      toast.error(payload?.error?.email)
    },
  },
})

export const getSignUpData = (state: any) => state.signUp.signUpDetails

export const {clearSignUpData} = signUpSlice.actions

export default signUpSlice.reducer
